import { lazy } from '@loadable/component';

const ConfirmPasswordField = lazy(() =>
  import(
    /* webpackChunkName: "confirm_password_field" */
    './confirm_password_field'
  )
);

export default ConfirmPasswordField;
